import MonzoFull from 'marketing-website/components/icons/MonzoFull';
import heroImage from 'marketing-website/media/images/pages/case-studies/deliveroo/cover@2x.jpg';
import image01a from 'marketing-website/media/images/pages/case-studies/monzo/image01a@2x.jpg';
import image01b from 'marketing-website/media/images/pages/case-studies/monzo/image01b@2x.jpg';
import image02a from 'marketing-website/media/images/pages/case-studies/monzo/image02a@2x.jpg';
import image02b from 'marketing-website/media/images/pages/case-studies/monzo/image02b@2x.jpg';
import image03a from 'marketing-website/media/images/pages/case-studies/monzo/image03a@2x.jpg';
import image04a from 'marketing-website/media/images/pages/case-studies/monzo/image04a@2x.jpg';
import image05a from 'marketing-website/media/images/pages/case-studies/monzo/image05a@2x.jpg';
import image05b from 'marketing-website/media/images/pages/case-studies/monzo/image05b@2x.jpg';
import monzoStats from 'marketing-website/media/images/pages/case-studies/monzo/monzo-stats@2x.jpg';

const monzoAssets = {
  heroImage: {
    src: heroImage,
    srcSet: heroImage,
    alt: '',
  },
  heroLogo: MonzoFull,
  statsImage: {
    alt: '',
    maxWidth: 1290,
    src: monzoStats,
  },
  singleImages: {
    first: {
      src: image04a,
      maxWidth: 1141,
      alt: '',
    },
  },
  doubleImages: {
    first: [
      {
        src: image01a,
        maxWidth: 536,
        alt: '',
      },
      {
        src: image01b,
        maxWidth: 551,
        alt: '',
      },
    ],
    second: [
      {
        src: image02a,
        maxWidth: 460,
        alt: '',
      },
      {
        src: image05b,
        maxWidth: 494,
        alt: '',
      },
    ],
    third: [
      {
        src: image03a,
        maxWidth: 536,
        alt: '',
      },
      {
        maxWidth: 400,
        copy:
          '"The last designer to join the team, she was onboarded with Marvel in 30 minutes, which is really quick."',
      },
    ],
    fourth: [
      {
        src: image05a,
        maxWidth: 550,
        alt: '',
      },
      {
        src: image02b,
        maxWidth: 460,
        alt: '',
      },
    ],
  },
  stats: [
    {
      id: 0,
      stat: '3000',
      title: 'Artboards',
      copy:
        "Marvel is compatible with Sketch and supported the team's big projects",
    },
    {
      id: 1,
      stat: '100+',
      title: 'Prototypes',
      copy:
        'Marvel enables the team to scale and supports high volumes of projects',
    },
    {
      id: 2,
      stat: '2',
      title: 'Weeks to Ship',
      copy:
        'Prototyping with Marvel allows the team to accelerate their entire design process',
    },
  ],
};

export default monzoAssets;



// WEBPACK FOOTER //
// ./src/configs/caseStudies/monzo.js